import { createContext } from "react";

export const AuthContext = createContext<{
  isLoggedIn: boolean;
  token: string | null;
  mentor: boolean;
  mentorData: any;
  user: any;
  login: (
    mentor: boolean,
    mentorData: any,
    token: string | null,
    user: any
  ) => void;
  logout: () => void;
}>({
  isLoggedIn: false,
  token: null,
  mentor: false,
  mentorData: null,
  user: null,
  login: (
    mentor: boolean,
    mentorData: any,
    token: string | null,
    user: any
  ) => {},
  logout: () => {},
});
